import type { StaticLayerPayload } from "@config";
import { FullscreenLibrary } from "@library-combos/fullscreen";
import type { ComponentType } from "react";
import { Container } from "../Container";

const Views: Record<string, ComponentType<StaticLayerPayload>> = {
  default: FullscreenLibrary,
};

export const FullScreen = ({ entity }: StaticLayerPayload) => (
  <Container entity={entity} views={Views} />
);
